<template>
    <div class="form-floating mb-4">
        <textarea class="form-control" :placeholder="placeholder" :name="id" :id="id" style="height: 100px" @change="setValue($event)">{{ getValue() }}</textarea>
        <label :for="id">{{ title }}</label>
    </div>
</template>
<script>
export default {
    name:    'TextareaField',
    props:   ['placeholder', 'id', 'title'],
    methods: {
        setValue(event) {
            this.$store.commit('results/setQuestion', {
                id:    this.id,
                value: event.currentTarget.value
            })
        },
        getValue() {
            const question = this.$store.getters['results/getQuestionById'](this.id);

            if(question) {
                return question.value;
            }

            return null;
        }
    }
}
</script>
